import { action } from 'satcheljs/lib/legacy';
import { addEventToMyCalendar } from 'owa-meeting-message-actions';
import itemId from 'owa-service/lib/factory/itemId';
import { MeetingRequestViewState } from '../store/schema/MeetingRequestViewState';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';

export default action('addGroupEventToCalendar')(function addGroupEventToCalendar(
    message: MeetingRequestMessageType,
    groupId: string,
    viewState: MeetingRequestViewState
) {
    const id = itemId({
        Id: message.ItemId.Id,
        ChangeKey: message.ItemId.ChangeKey,
    });
    viewState.groupEventAdded = true;
    addEventToMyCalendar(id, groupId);
});
